import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetTc } from "../redux/actions/teams/members/GetTcAction";

const Policy = () => {
  const dispatch = useDispatch();
  const [content, setContent] = useState("");

  const { response, loading, error } = useSelector((state) => state.getTc);

  useEffect(() => {
    dispatch(GetTc());
  }, [dispatch]);

  useEffect(() => {
    if (response?.data) {
      setContent(response.data);
    }
  }, [response]);

  if (loading) return <div className="text-center p-5">Loading...</div>;
  if (error) return <div className="text-center text-danger p-5">{error.data}</div>;

  return (
    <div className="content-wrapper" style={{ backgroundColor: "#f5f5f5" }}>
      <section className="main-section">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8">
              <div className="p-4 shadow rounded bg-white">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5>Terms and Conditions</h5>
                </div>

                <div
                  className="p-2"
                  style={{ minHeight: "150px" }}
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Policy;